import { useCallback, useMemo } from 'react';
import abiBUSD from '../config/abi/abiBUSD.json';
import abiJoinPool from '../config/abi/abiJoinPool.json';
import abiJoinPoolV1 from '../config/abi/abiJoinPoolV1.json';

import box from '../config/abi/box.json';
import market from '../config/abi/market.json';

import idoTokenClaimAbi from '../config/abi/idoTokenClaim.json';
import idoTokenClaimDailyAbi from '../config/abi/idoTokenClaimDaily.json';
import { IDO_CLAIM_TYPE_DAILY } from '../constants';

import { getContract } from '../utils';
import { useActiveWeb3React } from './index';import { useAccount, useConnectorClient } from 'wagmi';
import { useWeb3ModalState } from '@web3modal/wagmi/react';
import { providers } from 'ethers'

// returns null on errors
// export function useContract(address, ABI, withSignerIfPossible = true) {
//   const { library, account } = useActiveWeb3React()

//   return useMemo(() => {
//     if (!address || !ABI || !library) return null;
//     try {
//       return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
//     } catch (error) {
//       console.error('Failed to get contract', error);
//       return null;
//     }
//   }, [address, ABI, library, withSignerIfPossible, account]);
// }

export function clientToSigner(client) {
    const { chain, transport } = client
    const network = {
        chainId: chain?.id,
        name: chain?.name,
        ensAddress: chain?.contracts?.ensRegistry?.address,
    }
    const provider = new providers.Web3Provider(transport, network)
    return provider
}

export function useContract(addresss, ABI, withSignerIfPossible = true) {
    const { address } = useAccount();
    const { selectedNetworkId } = useWeb3ModalState()
    let chainId = selectedNetworkId ? selectedNetworkId : 0
    let account = address
    const { data: client } = useConnectorClient({ chainId })
    let library = client ? clientToSigner(client) : undefined

    return useMemo(() => {
        if (!addresss || !ABI || !library) return null;
        try {
            return getContract(
                addresss,
                ABI,
                library,
                withSignerIfPossible && account ? account : undefined
            );
        } catch (error) {
            console.error("Failed to get contract", error);
            return null;
        }
    }, [addresss, ABI, library, withSignerIfPossible, account]);
}

export function useBUSDContract(address) {
  return useContract(address, abiBUSD);
}

export function useJoinPoolContract(address, oldVersion) {  
  let _abi;
  
  if(oldVersion === true) {
    _abi = abiJoinPoolV1;
  }
  else {
    _abi = abiJoinPool;
  }
  
  return useContract(address, _abi, true);
}

export function useJoinPoolContractV1(address) {  
  return useContract(address, abiJoinPoolV1, true);
}

export function useIdoTokenClaimContract(scAddr) {
    return useContract(scAddr, idoTokenClaimAbi);
}

export function useClaimDailyContract(scAddr) {
  return useContract(scAddr, idoTokenClaimDailyAbi);
}

export function useBoxContract(address) {
  return useContract(address, box, true)
}
export function useBoxMarketContract(address) {
  return useContract(address, market, true)
}

export function useMyBoxContract(address) {
  return useContract(address, box , true)
}